/**
 * Gift Wrap Auto-Cleanup - Robust Version with polling & diagnostics
 * Replace your current script with this one.
 */

(function($) {
  'use strict';

  var GiftWrapCleanup = {
    // keys we will probe inside wrap.properties for the linked product reference
    LINKED_KEYS: ['_Linked Variant ID', 'Linked Variant ID', 'variant_id', 'Variant ID', 'Product Name', 'Product', 'product_name', 'product', 'Product Title', 'ProductTitle', 'Linked Product', 'linked_product'],
    LINKED_VARIANT_KEYS: ['_Linked Variant ID', 'Linked Variant ID', 'variant_id', 'Variant ID'],
    LINKED_NAME_KEYS: ['Product Name', 'Product', 'product_name', 'product', 'Product Title', 'ProductTitle', 'Linked Product', 'linked_product'],
    followupTimers: [],

    init: function() {
      this.bindEvents();
      // initial cleanup on load (delayed slightly to allow theme to finish)
      setTimeout(this.cleanupOrphans.bind(this), 700);
    },

    bindEvents: function() {
      var self = this;

      // On click of remove controls: capture pre-change snapshot, then wait for a real cart change
      $(document).on('click', '.cart__remove, .ajax-cart__delete, [data-ajax-cart-delete]', function(e) {
        console.debug('[GiftWrapCleanup] remove button clicked');
        // get a snapshot of current cart items
        $.getJSON('/cart.js').done(function(cartBefore) {
          // start waiting for cart change; when detected, run cleanup
          self.waitForCartChange(cartBefore, 3000 /* ms */)
            .then(function(cartAfter) {
              console.debug('[GiftWrapCleanup] cart changed (click flow). Running cleanup.');
              self.cleanupOrphansWithRefresh();
              self.scheduleFollowupCleanup();
            })
            .catch(function() {
              console.debug('[GiftWrapCleanup] waitForCartChange timed out for click flow – still running cleanup as fallback.');
              self.cleanupOrphansWithRefresh();
              self.scheduleFollowupCleanup();
            });
        }).fail(function() {
          console.debug('[GiftWrapCleanup] failed to fetch /cart.js before click; running cleanup after short delay.');
          setTimeout(function() {
            self.cleanupOrphansWithRefresh();
            self.scheduleFollowupCleanup();
          }, 700);
        });
      });

      // Listen for theme events — run cleanup when they appear
      $(document).on('cart:updated ajaxCart.success cart.requestComplete cart:refresh ajaxCart.updated', function() {
        console.debug('[GiftWrapCleanup] cart event fired — running cleanup');
        // run immediately, but verify by fetching cart to reduce race possibility
        var selfRef = self;
        setTimeout(function() {
          selfRef.cleanupOrphansWithRefresh();
          selfRef.scheduleFollowupCleanup();
        }, 80);
      });

      // If the theme creates an ajax cart object, try to hook into its update completion if available
      if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
        // can't directly override, but we can monitor cart.js changes after calling updateView in removeGiftWrap
      }

      // For single-page stores or dynamic cart DOM changes: fallback mutation observer
      this.observeCartDOM();
    },

    observeCartDOM: function() {
      try {
        var cartContainer = document.querySelector('.cart-items, .ajax-cart__products, .cart__cards, .ajax-cart__list');
        if (!cartContainer) return;
        var self = this;
        var mo = new MutationObserver(function(muts) {
          // small debounce
          if (self._domTimer) clearTimeout(self._domTimer);
          self._domTimer = setTimeout(function() {
            console.debug('[GiftWrapCleanup] DOM mutation detected in cart container — running cleanup.');
            self.cleanupOrphansWithRefresh();
          }, 220);
        });
        mo.observe(cartContainer, { childList: true, subtree: true });
      } catch (err) {
        // ignore
      }
    },

    scheduleFollowupCleanup: function() {
      var self = this;
      if (this.followupTimers && this.followupTimers.length) {
        this.followupTimers.forEach(function(timerId) {
          clearTimeout(timerId);
        });
      }
      this.followupTimers = [
        setTimeout(function() { self.cleanupOrphansWithRefresh(); }, 600),
        setTimeout(function() { self.cleanupOrphansWithRefresh(); }, 1400)
      ];
    },

    // Wait for the cart returned by /cart.js to be different from the given snapshot.
    // Resolves with the new cart, or rejects on timeout.
    waitForCartChange: function(cartBefore, timeoutMs) {
      var self = this;
      var interval = 200;
      var elapsed = 0;

      return new Promise(function(resolve, reject) {
        function check() {
          $.getJSON('/cart.js').done(function(cartNow) {
            // Compare by items count and by item keys list
            var beforeKeys = (cartBefore && cartBefore.items || []).map(function(i) { return i.key; }).sort().join(',');
            var nowKeys = (cartNow && cartNow.items || []).map(function(i) { return i.key; }).sort().join(',');

            // Also check item titles (in case keys remain same but quantity changed)
            var beforeTitles = (cartBefore && cartBefore.items || []).map(function(i) { return i.product_title + '::' + (i.quantity || 0); }).join('||');
            var nowTitles = (cartNow && cartNow.items || []).map(function(i) { return i.product_title + '::' + (i.quantity || 0); }).join('||');

            if (beforeKeys !== nowKeys || beforeTitles !== nowTitles) {
              console.debug('[GiftWrapCleanup] detected cart difference — resolving waitForCartChange', { beforeKeys, nowKeys });
              resolve(cartNow);
              return;
            }

            elapsed += interval;
            if (elapsed >= timeoutMs) {
              reject(new Error('timeout'));
              return;
            }
            setTimeout(check, interval);
          }).fail(function() {
            elapsed += interval;
            if (elapsed >= timeoutMs) return reject(new Error('timeout'));
            setTimeout(check, interval);
          });
        }

        // start
        setTimeout(check, 80);
      });
    },

    isGiftWrapItem: function(title) {
      if (!title) return false;
      var lowerTitle = title.toLowerCase();
      return lowerTitle.includes('gift wrap') || lowerTitle.includes('gift wrapping') || lowerTitle.includes('giftwrap') || lowerTitle.includes('gift-wrap');
    },

    // returns the best candidate value for linked product from properties (may be product title or variant id)
    getLinkedProductFromProperties: function(properties) {
      if (!properties) return null;

      for (var i = 0; i < this.LINKED_KEYS.length; i++) {
        var k = this.LINKED_KEYS[i];
        if (properties.hasOwnProperty(k) && properties[k]) {
          return properties[k];
        }
      }

      // try fuzzy keys (lowercase)
      for (var pk in properties) {
        if (!properties.hasOwnProperty(pk)) continue;
        var pl = pk.toLowerCase();
        if (pl.indexOf('product') !== -1 || pl.indexOf('linked') !== -1 || pl.indexOf('variant') !== -1) {
          if (properties[pk]) return properties[pk];
        }
      }

      return null;
    },
    getLinkedVariantId: function(properties) {
      if (!properties) return null;
      for (var i = 0; i < this.LINKED_VARIANT_KEYS.length; i++) {
        var key = this.LINKED_VARIANT_KEYS[i];
        if (properties.hasOwnProperty(key) && properties[key]) {
          return properties[key];
        }
      }
      return null;
    },
    getLinkedProductName: function(properties) {
      if (!properties) return null;
      for (var i = 0; i < this.LINKED_NAME_KEYS.length; i++) {
        var key = this.LINKED_NAME_KEYS[i];
        if (properties.hasOwnProperty(key) && properties[key]) {
          return properties[key];
        }
      }
      return null;
    },

    cleanupOrphans: function() {
      var self = this;
      console.debug('[GiftWrapCleanup] cleanupOrphans called');

      $.getJSON('/cart.js').done(function(cart) {
        var giftWraps = [];
        var productNames = [];

        cart.items.forEach(function(item) {
          if (self.isGiftWrapItem(item.product_title)) {
            giftWraps.push(item);
          } else {
            productNames.push(item.product_title);
          }
        });

        giftWraps.forEach(function(wrap) {
          var linkedVariantId = self.getLinkedVariantId(wrap.properties);
          var linkedName = self.getLinkedProductName(wrap.properties);
          var linkedVal = linkedVariantId || linkedName || self.getLinkedProductFromProperties(wrap.properties);
          if (!linkedVal) {
            console.debug('[GiftWrapCleanup] gift wrap missing linked property; skipping', wrap);
            return;
          }

          var productExists = false;

          if (linkedVariantId) {
            productExists = cart.items.some(function(it) {
              if (self.isGiftWrapItem(it.product_title)) return false;
              return it.variant_id && String(it.variant_id) === String(linkedVariantId);
            });
          }

          if (!productExists && linkedName) {
            productExists = productNames.some(function(pname) {
              return pname === linkedName || pname.indexOf(linkedName) !== -1 || linkedName.indexOf(pname) !== -1;
            });
          }

          if (!productExists) {
            // fallback to handles or raw linked value comparisons
            productExists = cart.items.some(function(it) {
              if (self.isGiftWrapItem(it.product_title)) return false;
              if (it.product_handle && String(it.product_handle) === String(linkedVal)) return true;
              return false;
            });
          }

          if (!productExists) {
            console.debug('[GiftWrapCleanup] removing orphaned gift wrap', { wrapKey: wrap.key, linked: linkedVal });
            self.removeGiftWrap(wrap.key, linkedVal, false);
          } else {
            console.debug('[GiftWrapCleanup] linked product still exists for wrap - skipping', { wrapKey: wrap.key, linked: linkedVal });
          }
        });
      }).fail(function() {
        console.debug('[GiftWrapCleanup] /cart.js fetch failed during cleanupOrphans');
      });
    },

    cleanupOrphansWithRefresh: function() {
      var self = this;
      console.debug('[GiftWrapCleanup] cleanupOrphansWithRefresh called');

      $.getJSON('/cart.js').done(function(cart) {
        var giftWraps = [];
        var productNames = [];
        var orphansFound = false;

        cart.items.forEach(function(item) {
          if (self.isGiftWrapItem(item.product_title)) {
            giftWraps.push(item);
          } else {
            productNames.push(item.product_title);
          }
        });

        giftWraps.forEach(function(wrap) {
          var linkedVariantId = self.getLinkedVariantId(wrap.properties);
          var linkedName = self.getLinkedProductName(wrap.properties);
          var linkedVal = linkedVariantId || linkedName || self.getLinkedProductFromProperties(wrap.properties);
          if (!linkedVal) return;

          var productExists = false;

          if (linkedVariantId) {
            productExists = cart.items.some(function(it) {
              if (self.isGiftWrapItem(it.product_title)) return false;
              return it.variant_id && String(it.variant_id) === String(linkedVariantId);
            });
          }

          if (!productExists && linkedName) {
            productExists = productNames.some(function(pname) {
              return pname === linkedName || pname.indexOf(linkedName) !== -1 || linkedName.indexOf(pname) !== -1;
            });
          }

          if (!productExists) {
            productExists = cart.items.some(function(it) {
              if (self.isGiftWrapItem(it.product_title)) return false;
              if (it.product_handle && String(it.product_handle) === String(linkedVal)) return true;
              return false;
            });
          }

          if (!productExists) {
            orphansFound = true;
            console.debug('[GiftWrapCleanup] orphan identified (with refresh):', wrap.key, linkedVal);
            self.removeGiftWrap(wrap.key, linkedVal, true);
          }
        });

        // duplicates check (if you have two wraps for same linkedVal)
        var seen = {};
        giftWraps.forEach(function(wrap) {
          var linkedVariantId = self.getLinkedVariantId(wrap.properties);
          var linkedName = self.getLinkedProductName(wrap.properties);
          var linkedVal = linkedVariantId || linkedName || self.getLinkedProductFromProperties(wrap.properties);
          if (!linkedVal) return;
          if (seen[linkedVal]) {
            orphansFound = true;
            console.debug('[GiftWrapCleanup] duplicate wrap found - removing extra', wrap.key, linkedVal);
            self.removeGiftWrap(wrap.key, linkedVal, true);
          } else {
            seen[linkedVal] = true;
          }
        });

        if (!orphansFound) {
          console.debug('[GiftWrapCleanup] no orphans found in cleanupOrphansWithRefresh');
        }
      }).fail(function() {
        console.debug('[GiftWrapCleanup] /cart.js fetch failed during cleanupOrphansWithRefresh');
      });
    },

    removeGiftWrap: function(cartKey, productNameOrId, shouldRefresh) {
      console.debug('[GiftWrapCleanup] removeGiftWrap called', { cartKey: cartKey, linked: productNameOrId, refresh: !!shouldRefresh });

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: cartKey,
          quantity: 0
        },
        dataType: 'json',
        success: function(cart) {
          console.debug('[GiftWrapCleanup] removeGiftWrap success', cartKey);
          if (shouldRefresh) {
            $(document).trigger('cart:updated');

            if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
              try {
                window.PXUTheme.jsAjaxCart.updateView();
              } catch (err) {
                console.debug('[GiftWrapCleanup] PXUTheme.updateView threw', err);
              }
            }

            if (window.location.pathname.indexOf('/cart') !== -1) {
              setTimeout(function() {
                try { location.reload(); } catch (e) { /* ignore */ }
              }, 450);
            }
          }
        },
        error: function(xhr) {
          console.debug('[GiftWrapCleanup] removeGiftWrap error', xhr && xhr.responseText);
        }
      });
    }
  };

  $(document).ready(function() {
    GiftWrapCleanup.init();
  });

  $(document).on('cart:loaded ajaxCart.init', function() {
    setTimeout(function() { GiftWrapCleanup.cleanupOrphans(); }, 300);
  });

})(jQuery);
